import { defineMessages } from 'react-intl';

export const epicMessages = defineMessages({
  jobCompletedTitle: {
    id: 'XmxMbO',
    defaultMessage: 'CSV Successfully Processed',
    description: 'Title for the notification that is shown when the import job is completed',
  },
  jobFailedTitle: {
    id: 'UuvQVB',
    defaultMessage: 'Import process failed',
    description: 'Title for the notification that is shown when the import job has failed',
  },
  jobFailedMessage: {
    id: 'juDhs9',
    defaultMessage: 'Your import failed unexpectedly. Please try again or contact support.',
    description: 'Message of the notification that is shown when the import job has failed',
  },
  processed: {
    id: 'xgczou',
    defaultMessage: 'We successfully processed {processed, plural, one {# row} other {# rows}}.',
    description: 'Processed',
  },
  processedWithWarnings: {
    id: '2sYwCo',
    defaultMessage:
      'We successfully processed {processed, plural, one {# row} other {# rows}} with {warningsCount, plural, one {# warning} other {# warnings}}.',
    description: 'Warnings',
  },
  failed: {
    id: 'KZwlEe',
    defaultMessage:
      '{failedCount, plural, one {# row} other {# rows}} had invalid or missing data. Please correct the data in the file and try again.',
    description: 'Failed',
  },
  viewImportSummary: {
    id: 'Y19IDD',
    defaultMessage: 'View import summary',
    description: 'Call to action for the user to click on to view the details of their summary',
  },
  orderProgressNotificationTitle: {
    id: 'R1WQZH',
    defaultMessage: 'Orders Importing',
    description: 'Order progress notification title',
  },
  orderProgressNotificationBody: {
    id: '46KRS/',
    defaultMessage: 'Your orders are currently being imported. <a>View import details</a>',
    description: 'Order progress notification body',
  },
});
